const formatTime = (time: number) => {
  return time < 10 ? `0${time}` : time
}

export const getFormattedTimerValue = (days: number, hours: number, minutes: number, seconds: number): string => {
  const isMoreThanOneDay = days > 0
  const isMoreThanOneHour = !isMoreThanOneDay && hours > 0
  const isLessThanOneHour = !isMoreThanOneDay && hours <= 0

  if (isMoreThanOneDay) {
    return `${formatTime(days)}d ${formatTime(hours)}h`
  } else if (isMoreThanOneHour) {
    return `${formatTime(hours)}h ${formatTime(minutes)}m`
  } else if (isLessThanOneHour) {
    return `${formatTime(minutes)}m ${formatTime(seconds)}s`
  }

  return null
}
